export function calculateOffset(page: number, limit: number) {
  // page + 1, because table start pages from 0
  return limit * (page + 1) - limit;
}
